import { SearchXIcon } from 'lucide-react'

import { PageState } from '#admin/components/page-state.tsx'

/**
 * A page that is not there — **or not there for you**, and deliberately the same screen.
 *
 * Pages outside the caller's role (`/settings/roles` without `access.manage`, `/platform`
 * without staff access) answer with `notFound()` rather than a refusal, on the reasoning the
 * API's module guard gives: a tenant operator should not learn that a platform console exists.
 * So this cannot say which of the two it is, and says both honestly instead.
 */
export function NotFoundView() {
  return (
    <PageState icon={<SearchXIcon />} title="This page isn’t available" offerSignOut>
      It does not exist, or your role in this edition does not include it. If somebody sent you a
      link, check you are signed in with the account they meant.
    </PageState>
  )
}
